export default "__VITE_ASSET__N5Ny3wzSDgsXWrbrPUpL0g__"